import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { useTimeout } from '~/composables/useTimeout';
import { useLoginStore } from '~/composables/_next/stores/useLoginStore';
import { useLocalization } from './_next/useLocalization';
import { gtmPushEvent } from '~/helpers/gtm';
var state = reactive({
  isCartSidebarOpen: false,
  isCartPopupOpen: false,
  isWishlistSidebarOpen: false,
  isCreateRecipeWishlistSidebarOpen: false,
  isAddRecipeToWishlistSidebarOpen: false,
  isLoginModalOpen: false,
  isNewsletterModalOpen: false,
  isCategoryGridView: true,
  isFilterSidebarOpen: false,
  isFilterButtonVisible: true,
  isMobileMenuOpen: false,
  isStoreChosen: false,
  isNewPasswordModalOpen: false,
  isCheckoutShippingAddressModalOpen: false,
  isCheckoutBillingAddressModalOpen: false,
  redirectTarget: null,
  loginCallbackAction: null,
  loginDisplay: 'login',
  loginAction: null,
  recipeToAdd: null,
  addRecipesWishlistCallbackAction: null,
  isEditAddressModalOpen: false,
  isDeleteAddressModalOpen: false,
  isAddressFormShown: false,
  isProductsGenericSurvey: false,
  isOperationSkinCare: false,
  isShippingFormModalDisplayedFromUnknownModal: false,
  backInStockModalProduct: null,
  addToCartModalProduct: null
});
var _useTimeout = useTimeout(1000 * 5),
  cartPopupReady = _useTimeout.ready,
  startCartPopup = _useTimeout.start,
  stopCartPopup = _useTimeout.stop;
var useUiState = function useUiState() {
  var _useLoginStore = useLoginStore(),
    storePreviousRoutePath = _useLoginStore.storePreviousRoutePath,
    storeNextRoutePath = _useLoginStore.storeNextRoutePath,
    nextRoutePath = _useLoginStore.nextRoutePath;
  var _useNuxt2App = useNuxt2App(),
    app = _useNuxt2App.app;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale,
    country = _useLocalization.country,
    currency = _useLocalization.currency;
  var router = useRouter();
  var isMobileMenuOpen = computed(function () {
    return state.isMobileMenuOpen;
  });
  var toggleMobileMenu = function toggleMobileMenu() {
    state.isMobileMenuOpen = !state.isMobileMenuOpen;
  };
  var isCartSidebarOpen = computed(function () {
    return state.isCartSidebarOpen;
  });
  var openCartSidebar = function openCartSidebar() {
    if (state.isMobileMenuOpen) toggleMobileMenu();
    var modal = document.querySelector('dialog.cart-sidebar');
    modal.showModal();
    state.isCartSidebarOpen = true;
  };
  var closeCartSidebar = function closeCartSidebar() {
    var modal = document.querySelector('dialog.cart-sidebar');
    modal.close();
    state.isCartSidebarOpen = false;
  };
  var toggleCartSidebar = function toggleCartSidebar() {
    var modal = document.querySelector('dialog.cart-sidebar');
    if (modal.open) {
      modal.close();
    } else {
      openCartSidebar();
    }
  };
  var toggleLanguageModal = function toggleLanguageModal() {
    var modal = document.querySelector('dialog.modal-locale-choice');
    if (modal.open) {
      modal.close();
    } else {
      modal.showModal();
    }
  };
  var isCartPopupOpen = computed(function () {
    return state.isCartPopupOpen;
  });
  var scrollToTop = function scrollToTop() {
    return window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  var showCartPopup = function showCartPopup() {
    startCartPopup();
    scrollToTop();
  };
  var hideCartPopup = function hideCartPopup() {
    stopCartPopup();
  };
  watch(cartPopupReady, function (v) {
    state.isCartPopupOpen = !v;
  });
  var isWishlistSidebarOpen = computed(function () {
    return state.isWishlistSidebarOpen;
  });
  var toggleWishlistSidebar = function toggleWishlistSidebar() {
    if (state.isMobileMenuOpen) toggleMobileMenu();
    state.isWishlistSidebarOpen = !state.isWishlistSidebarOpen;
  };
  var isCreateRecipeWishlistSidebarOpen = computed(function () {
    return state.isCreateRecipeWishlistSidebarOpen;
  });
  var isAddRecipeToWishlistSidebarOpen = computed(function () {
    return state.isAddRecipeToWishlistSidebarOpen;
  });
  var recipeToAdd = computed(function () {
    return state.recipeToAdd;
  });
  var toggleCreateRecipeWishlistSidebar = function toggleCreateRecipeWishlistSidebar() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (state.isMobileMenuOpen) toggleMobileMenu();
    state.isCreateRecipeWishlistSidebarOpen = !state.isCreateRecipeWishlistSidebarOpen;
    var modal = document.querySelector('dialog.create-recipe-wishlist-sidebar');
    if (modal.open) {
      modal.close();
    } else {
      modal.showModal();
    }
    if (state.addRecipesWishlistCallbackAction && !state.isCreateRecipeWishlistSidebarOpen) {
      state.addRecipesWishlistCallbackAction();
      state.addRecipesWishlistCallbackAction = null;
    }
    if (typeof callback === 'function') {
      state.addRecipesWishlistCallbackAction = callback;
    } else {
      state.addRecipesWishlistCallbackAction = null;
    }
  };
  var toggleAddRecipeToWishlistSidebar = function toggleAddRecipeToWishlistSidebar(recipe) {
    if (state.isMobileMenuOpen) toggleMobileMenu();
    state.recipeToAdd = recipe;
    var modal = document.querySelector('dialog.add-recipe-to-wishlist-sidebar');
    if (modal.open) {
      modal.close();
    } else {
      modal.showModal();
    }
  };
  var toggleStoreSwitcherModal = function toggleStoreSwitcherModal() {
    var modal = document.querySelector('dialog.modal-locale-choice');
    if (!modal) {
      return;
    }
    if (modal.open) {
      modal.close();
    } else {
      modal.showModal();
      gtmPushEvent('store_switcher_modal_opened', {
        event: 'generic_event',
        event_category: 'engagement',
        event_action: 'change',
        event_label: 'store_switcher_modal_opened',
        event_name: 'store_switcher_modal_opened',
        country: country,
        currency: currency,
        language: locale,
        trigger: 'manual'
      });
    }
  };
  var isLoginModalOpen = computed(function () {
    return state.isLoginModalOpen;
  });
  var setLoginDisplay = function setLoginDisplay() {
    var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    state.loginDisplay = display;
  };

  /**
   * Function to go to the login with optional redirection and callback.
   *
   * @param {Object} [params] - Optional parameters for the function.
   * @param {string | null} [params.nextRoutePath] - The target path to redirect to after login.
   * @param {string | null} [params.previousRoutePath] - The previous route path to store for navigation purposes.
   * @param {string | (() => any | Promise<any>) | null} [params.loginAction] - The optional callback function, string, or promise to execute after login.
   * @returns {Promise<void>} - A promise that resolves once the operation is complete.
   */
  function handleLoginNavigation() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$nextRoutePath = _ref.nextRoutePath,
      nextRoutePath = _ref$nextRoutePath === void 0 ? null : _ref$nextRoutePath,
      _ref$loginAction = _ref.loginAction,
      loginAction = _ref$loginAction === void 0 ? null : _ref$loginAction,
      _ref$previousRoutePat = _ref.previousRoutePath,
      previousRoutePath = _ref$previousRoutePat === void 0 ? null : _ref$previousRoutePat,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? 'login' : _ref$display;
    storePreviousRoutePath(previousRoutePath);
    storeNextRoutePath(nextRoutePath);
    state.loginAction = loginAction;
    router.push(app.localePath('/login'));
  }
  function resetLogin() {
    state.redirectTarget = null;
    state.loginAction = null;
    state.loginDisplay = 'login';
  }
  var isProductsGenericSurvey = computed(function () {
    return state.isProductsGenericSurvey;
  });
  var toggleGenericSurvey = function toggleGenericSurvey() {
    state.isProductsGenericSurvey = !state.isProductsGenericSurvey;
  };
  var setRedirectTarget = function setRedirectTarget() {
    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    state.redirectTarget = target;
  };
  var doLoginAction = function doLoginAction() {
    if (state.loginAction) {
      state.loginAction();
    }
    if (nextRoutePath.value) {
      router.replace(app.localePath(nextRoutePath.value));
    }
    state.loginAction = null;
  };
  var isNewPasswordModalOpen = computed(function () {
    return state.isNewPasswordModalOpen;
  });
  var togglePasswordModal = function togglePasswordModal() {
    if (state.isMobileMenuOpen) toggleMobileMenu();
    state.isNewPasswordModalOpen = !state.isNewPasswordModalOpen;
  };
  var openPasswordModal = function openPasswordModal() {
    if (state.isMobileMenuOpen) toggleMobileMenu();
    state.isNewPasswordModalOpen = true;
  };
  var isNewsletterModalOpen = computed(function () {
    return state.isNewsletterModalOpen;
  });
  var toggleNewsletterModal = function toggleNewsletterModal() {
    state.isNewsletterModalOpen = !state.isNewsletterModalOpen;
  };
  var isCategoryGridView = computed(function () {
    return state.isCategoryGridView;
  });
  var changeToCategoryGridView = function changeToCategoryGridView() {
    state.isCategoryGridView = true;
  };
  var changeToCategoryListView = function changeToCategoryListView() {
    state.isCategoryGridView = false;
  };
  var isFilterSidebarOpen = computed(function () {
    return state.isFilterSidebarOpen;
  });
  var toggleFilterSidebar = function toggleFilterSidebar() {
    state.isFilterSidebarOpen = !state.isFilterSidebarOpen;
  };
  var isFilterButtonVisible = computed(function () {
    return state.isFilterButtonVisible;
  });
  var toggleFilterButton = function toggleFilterButton() {
    state.isFilterButtonVisible = !state.isFilterButtonVisible;
  };
  var isStoreChosen = computed(function () {
    return state.isStoreChosen;
  });
  var chooseStore = function chooseStore() {
    return state.isStoreChosen = true;
  };
  var removeStore = function removeStore() {
    return state.isStoreChosen = false;
  };
  var redirectTarget = computed(function () {
    return state.redirectTarget;
  });
  var loginDisplay = computed(function () {
    return state.loginDisplay;
  });
  var isEditAddressModalOpen = computed(function () {
    return state.isEditAddressModalOpen;
  });
  var toggleEditAddressModal = function toggleEditAddressModal() {
    state.isEditAddressModalOpen = !state.isEditAddressModalOpen;
  };
  var isDeleteAddressModalOpen = computed(function () {
    return state.isDeleteAddressModalOpen;
  });
  var toggleDeleteAddressModal = function toggleDeleteAddressModal() {
    state.isDeleteAddressModalOpen = !state.isDeleteAddressModalOpen;
  };
  var isCheckoutShippingAddressModalOpen = computed(function () {
    return state.isCheckoutShippingAddressModalOpen;
  });
  var toggleIsCheckoutShippingAddressModal = function toggleIsCheckoutShippingAddressModal() {
    state.isCheckoutShippingAddressModalOpen = !state.isCheckoutShippingAddressModalOpen;
  };
  var toggleShippingFormModalDisplayedFromUnknownModal = function toggleShippingFormModalDisplayedFromUnknownModal() {
    state.isShippingFormModalDisplayedFromUnknownModal = !state.isShippingFormModalDisplayedFromUnknownModal;
  };
  var isShippingFormModalDisplayedFromUnknownModal = computed(function () {
    return state.isShippingFormModalDisplayedFromUnknownModal;
  });
  var isCheckoutBillingAddressModalOpen = computed(function () {
    return state.isCheckoutBillingAddressModalOpen;
  });
  var toggleIsCheckoutBillingAddressModal = function toggleIsCheckoutBillingAddressModal() {
    state.isCheckoutBillingAddressModalOpen = !state.isCheckoutBillingAddressModalOpen;
  };
  var isAddressFormShown = computed(function () {
    return state.isAddressFormShown;
  });
  var toggleAddressFormVisible = function toggleAddressFormVisible() {
    state.isAddressFormShown = !state.isAddressFormShown;
  };
  var backInStockModalProduct = computed(function () {
    return state.backInStockModalProduct;
  });
  var openBackInStockModal = function openBackInStockModal(product) {
    state.backInStockModalProduct = product;
    var modal = document.querySelector('dialog.modal-back-in-stock');
    modal.showModal();
  };
  var closeBackInStockModal = function closeBackInStockModal() {
    state.backInStockModalProduct = null;
    var modal = document.querySelector('dialog.modal-back-in-stock');
    modal.close();
  };
  var addToCartModalProduct = computed(function () {
    return state.addToCartModalProduct;
  });
  var openAddToCartModal = function openAddToCartModal(product) {
    state.addToCartModalProduct = product;
    var modal = document.querySelector('dialog.modal-add-to-cart');
    modal.showModal();
  };
  var closeAddToCartModal = function closeAddToCartModal() {
    state.addToCartModalProduct = null;
    var modal = document.querySelector('dialog.modal-add-to-cart');
    modal.close();
  };
  watch(function () {
    return [state.isCheckoutShippingAddressModalOpen, state.isCheckoutBillingAddressModalOpen];
  }, function () {
    if (!state.isCheckoutShippingAddressModalOpen && !state.isCheckoutBillingAddressModalOpen) {
      state.isAddressFormShown = false;
    }
  });
  return {
    doLoginAction: doLoginAction,
    isCartSidebarOpen: isCartSidebarOpen,
    isCartPopupOpen: isCartPopupOpen,
    toggleLanguageModal: toggleLanguageModal,
    isWishlistSidebarOpen: isWishlistSidebarOpen,
    isLoginModalOpen: isLoginModalOpen,
    isProductsGenericSurvey: isProductsGenericSurvey,
    isNewsletterModalOpen: isNewsletterModalOpen,
    isCategoryGridView: isCategoryGridView,
    isFilterSidebarOpen: isFilterSidebarOpen,
    isFilterButtonVisible: isFilterButtonVisible,
    toggleFilterButton: toggleFilterButton,
    isMobileMenuOpen: isMobileMenuOpen,
    openCartSidebar: openCartSidebar,
    closeCartSidebar: closeCartSidebar,
    toggleCartSidebar: toggleCartSidebar,
    showCartPopup: showCartPopup,
    hideCartPopup: hideCartPopup,
    toggleWishlistSidebar: toggleWishlistSidebar,
    handleLoginNavigation: handleLoginNavigation,
    toggleGenericSurvey: toggleGenericSurvey,
    isNewPasswordModalOpen: isNewPasswordModalOpen,
    togglePasswordModal: togglePasswordModal,
    openPasswordModal: openPasswordModal,
    toggleNewsletterModal: toggleNewsletterModal,
    changeToCategoryGridView: changeToCategoryGridView,
    changeToCategoryListView: changeToCategoryListView,
    toggleFilterSidebar: toggleFilterSidebar,
    toggleMobileMenu: toggleMobileMenu,
    isStoreChosen: isStoreChosen,
    chooseStore: chooseStore,
    removeStore: removeStore,
    isCheckoutShippingAddressModalOpen: isCheckoutShippingAddressModalOpen,
    toggleIsCheckoutShippingAddressModal: toggleIsCheckoutShippingAddressModal,
    redirectTarget: redirectTarget,
    setRedirectTarget: setRedirectTarget,
    loginDisplay: loginDisplay,
    setLoginDisplay: setLoginDisplay,
    isEditAddressModalOpen: isEditAddressModalOpen,
    toggleEditAddressModal: toggleEditAddressModal,
    isDeleteAddressModalOpen: isDeleteAddressModalOpen,
    toggleDeleteAddressModal: toggleDeleteAddressModal,
    isCheckoutBillingAddressModalOpen: isCheckoutBillingAddressModalOpen,
    toggleIsCheckoutBillingAddressModal: toggleIsCheckoutBillingAddressModal,
    isAddressFormShown: isAddressFormShown,
    toggleAddressFormVisible: toggleAddressFormVisible,
    resetLogin: resetLogin,
    openAddToCartModal: openAddToCartModal,
    closeAddToCartModal: closeAddToCartModal,
    addToCartModalProduct: addToCartModalProduct,
    openBackInStockModal: openBackInStockModal,
    closeBackInStockModal: closeBackInStockModal,
    backInStockModalProduct: backInStockModalProduct,
    isCreateRecipeWishlistSidebarOpen: isCreateRecipeWishlistSidebarOpen,
    toggleCreateRecipeWishlistSidebar: toggleCreateRecipeWishlistSidebar,
    isAddRecipeToWishlistSidebarOpen: isAddRecipeToWishlistSidebarOpen,
    toggleAddRecipeToWishlistSidebar: toggleAddRecipeToWishlistSidebar,
    recipeToAdd: recipeToAdd,
    toggleShippingFormModalDisplayedFromUnknownModal: toggleShippingFormModalDisplayedFromUnknownModal,
    isShippingFormModalDisplayedFromUnknownModal: isShippingFormModalDisplayedFromUnknownModal,
    toggleStoreSwitcherModal: toggleStoreSwitcherModal
  };
};
export default useUiState;